import { render, staticRenderFns } from "./FolderProtection.vue?vue&type=template&id=fba3363c&"
import script from "./FolderProtection.vue?vue&type=script&lang=js&"
export * from "./FolderProtection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports